import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const MegaDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}><span className={styles.highlight}>Mega</span></p>
      <p className={styles.text}>
        Cazane de încălzire industrială cu tub cald, de tip MEGA - o combustie de lungă durată, care funcționează în modurile de încărcare manuală a combustibilului și a combustibilului. Sunt instalate în cazane transportabile și staționare cu sisteme închise de alimentare cu căldură. Gama de putere: 600-1500 kW. Schimbătorul de căldură al cazanului este căptușit cu piatră șamotă.
      </p>
      <p className={styles.text}>
        Cazanul este echipat cu un grătar din fontă, cu o suprafață mare, care asigură o combustie uniformă a combustibilului la diferite niveluri de umiditate. Cazanele funcționează la presiune ridicată - până la 3 bar, ceea ce permite instalarea echipamentelor în sisteme de înaltă presiune a lichidului de răcire. Temperatura cazanului MEGA este reglată de microprocesor sub forma unei unități de control PID.
      </p>
      <p className={styles.text}>
        Pentru a pune în funcțiune cazanul în modul automat de alimentare cu combustibil, este necesar să instalați suplimentar ușa sub arzătorul cu peleți, arzătorul în sine și buncărul de combustibil.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th>600 kW</th>
              <th>800 kW</th>
              <th>1000 kW</th>
              <th>1200 kW</th>
              <th>1500 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>49</td>
              <td>60</td>
              <td>75</td>
              <td>86</td>
              <td>98</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="7">Mărimea camerei de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adâncime</td>
              <td>mm</td>
              <td>1380</td>
              <td>1860</td>
              <td>1860</td>
              <td>2340</td>
              <td>2820</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>m³</td>
              <td>2,23</td>
              <td>3,01</td>
              <td>3,01</td>
              <td>3,79</td>
              <td>4,57</td>
            </tr>
            <tr>
              <td>Volumul apei în cazan</td>
              <td>m³</td>
              <td>1,9</td>
              <td>2,3</td>
              <td>2,8</td>
              <td>3,4</td>
              <td>4,0</td>
            </tr>
            <tr>
              <td>Greutatea cazanului, fără apă</td>
              <td>kg</td>
              <td>4500</td>
              <td>5200</td>
              <td>5850</td>
              <td>6700</td>
              <td>7600</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td>100-180</td>
              <td>100-180</td>
              <td>100-180</td>
              <td>100-180</td>
              <td>100-180</td>
            </tr>
            <tr>
              <td>Temperatura min recomandata a apei</td>
              <td>°C</td>
              <td>58</td>
              <td>58</td>
              <td>58</td>
              <td>58</td>
              <td>58</td>
            </tr>
            <tr>
              <td>Temperatura maxima a apei</td>
              <td>°C</td>
              <td>85</td>
              <td>85</td>
              <td>85</td>
              <td>85</td>
              <td>85</td>
            </tr>
            <tr>
              <td>Presiunea normala a apei</td>
              <td>mPa</td>
              <td>0,3</td>
              <td>0,3</td>
              <td>0,3</td>
              <td>0,3</td>
              <td>0,3</td>
            </tr>
            <tr>
              <td>Consum curent electric, max</td>
              <td>Wt</td>
              <td>1110</td>
              <td>1110</td>
              <td>1110</td>
              <td>1660</td>
              <td>1660</td>
            </tr>
            <tr>
              <td>Dimensiuni extern burlan</td>
              <td>mm</td>
              <td>450</td>
              <td>450</td>
              <td>500</td>
              <td>600</td>
              <td>600</td>
            </tr>
            <tr>
              <td>Diametrul țevilor rețelei de apă (Du)</td>
              <td>mm</td>
              <td>125(Fl)</td>
              <td>125(Fl)</td>
              <td>125(Fl)</td>
              <td>150(Fl)</td>
              <td>150(Fl)</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan={"7"}>Dimensiuni burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>1590</td>
              <td>1590</td>
              <td>1970</td>
              <td>2830</td>
              <td>2830</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>450</td>
              <td>450</td>
              <td>500</td>
              <td>600</td>
              <td>600</td>
            </tr>
            <tr>
              <td>Înălțime (min admisă)</td>
              <td>m</td>
              <td>16</td>
              <td>22</td>
              <td>24</td>
              <td>24</td>
              <td>30</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei (Du)</td>
              <td>mm</td>
              <td>2×50(Fl)</td>
              <td>2×50(Fl)</td>
              <td>2×65(Fl)</td>
              <td>2×65(Fl)</td>
              <td>2×65(Fl)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const MegaDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [2430, 2430, 2430, 2430, 2430] },
    { param: "B1", unit: "mm", values: [2080, 2080, 2080, 2080, 2080] },
    { param: "H", unit: "mm", values: [2670, 2670, 2870, 2870, 2870] },
    { param: "H1", unit: "mm", values: [2430, 2430, 2630, 2630, 2630] },
    { param: "H2", unit: "mm", values: [2082, 2082, 2263, 2224, 2224] },
    { param: "L", unit: "mm", values: [2950, 3400, 3400, 3880, 4330] },
    { param: "L1", unit: "mm", values: [1910, 2380, 2380, 2840, 3290] },
    { param: "L2", unit: "mm", values: [410, 410, 410, 410, 410] }
  ]


  const headers = ["Dimensiunile cazanului", "U.M.", "600 kW", "800 kW", "1000 kW", "1200 kW", "1500 kW"]


  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/MegaSchema.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
